// extracted by mini-css-extract-plugin
module.exports = {"pagination":"List_pagination_cSfhg","paginationText":"List_paginationText_4hplM","paginationButton":"List_paginationButton_1L_NP"};